(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  const fmt = (c) => new Intl.NumberFormat('es-ES', { style: 'currency', currency: cur }).format(c / 100);
  const pad = (n) => String(n).padStart(2, '0');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const dataEl = $('[data-md-data]');
  const D = dataEl ? JSON.parse(dataEl.textContent) : null;

  /* ---------- Producto: packs y modelos ---------- */
  const st = { pack: 2, slots: [], active: 0, ver: null };

  function firstOk(skip = []) {
    const i = D.modelos.findIndex((m, k) => m.ok && !skip.includes(k));
    return i < 0 ? 0 : i;
  }

  function packTotal(n, slots) {
    const pct = D.pct[n - 1] || 0;
    const sel = slots.slice(0, n).map((i) => D.modelos[i].price);
    const base = sel.reduce((a, p) => a + p, 0);
    const fijo = (D.fijo && D.fijo[n - 1]) || 0;
    // Con %: Shopify descuenta por unidad redondeando hacia abajo. Con importe fijo: se resta tal cual al pedido.
    const total = fijo
      ? Math.max(0, base - fijo)
      : sel.reduce((a, p) => a + p - Math.floor(p * pct / 100), 0);
    return { base, total, ahorro: base - total };
  }

  function slotsFor(n) {
    const s = st.slots.slice(0, n);
    while (s.length < n) s.push(s.length ? s[s.length - 1] : firstOk());
    return s;
  }

  function setPack(n, keepActive) {
    const prev = st.pack;
    st.pack = n;
    while (st.slots.length < n) st.slots.push(st.slots[st.slots.length - 1]);
    if (!keepActive) st.active = n > prev ? prev : Math.min(st.active, n - 1);
    st.ver = null;
    render();
  }

  function render() {
    if (!D) return;
    const n = st.pack;
    const t = packTotal(n, st.slots);

    $$('[data-md-pack]').forEach((el) => {
      const k = +el.dataset.mdPack;
      const sl = slotsFor(k);
      const pt = packTotal(k, sl);
      el.classList.toggle('is-on', k === n);
      el.querySelector('input').checked = k === n;
      $('[data-md-pack-total]', el).textContent = fmt(pt.total);
      const antes = $('[data-md-pack-antes]', el);
      antes.hidden = !pt.ahorro;
      antes.textContent = pt.ahorro ? fmt(pt.base) : '';
      $('[data-md-pack-ahorro]', el).textContent = pt.ahorro ? 'Ahorras ' + fmt(pt.ahorro) : fmt(pt.total) + ' / coche';
      $('[data-md-pack-cars]', el).innerHTML = sl.map((i) => `<img src="${D.modelos[i].thumb}" alt="" width="28" height="28">`).join('');
    });

    $('[data-md-total]').textContent = fmt(t.total);
    const ah = $('[data-md-ahorro]');
    ah.hidden = !t.ahorro;
    ah.textContent = t.ahorro ? ((n > 1 && !(D.fijo && D.fijo[n - 1]) && D.pct[n - 1]) ? '-' + D.pct[n - 1] + ' %' : '-' + fmt(t.ahorro)) : '';    $('[data-md-unidad]').textContent = n > 1 ? fmt(Math.round(t.total / n)) + ' por coche' : 'Envío con seguimiento';

    const reg = $('[data-md-regalo]');
    if (reg && D.conos) {
      const txt = (k) => D.conosTxt.replace('[n]', k * D.conos);
      const nuevo = `<small>Te llevas</small><strong>${txt(n)}</strong>`;
      const val = $('[data-md-regalo-valor]', reg);
      if (val) {
        val.hidden = !D.conosValor;
        val.textContent = D.conosValor ? fmt(D.conosValor * n) : '';
      }
      const p = $('[data-md-regalo-txt]', reg);
      if (p.innerHTML !== nuevo) {
        p.innerHTML = nuevo;
        if (!reduce) reg.animate([{ transform: 'scale(.97)', opacity: .6 }, { transform: 'scale(1)', opacity: 1 }], { duration: 220, easing: 'cubic-bezier(.23,1,.32,1)' });
      }
    }
    const slotsEl = $('[data-md-slots]');
    slotsEl.hidden = n === 1;
    slotsEl.innerHTML = n === 1 ? '' : st.slots.slice(0, n).map((i, k) => `
      <button type="button" role="tab" class="md-slot${k === st.active ? ' is-on' : ''}" data-md-slot="${k}" aria-selected="${k === st.active}">
        <img src="${D.modelos[i].coche || D.modelos[i].thumb}" alt="" width="140" height="84">
        <b>${D.modelos[i].name}</b>
        <small>Coche ${k + 1}${k === st.active ? ' · eligiendo' : ''}</small>
      </button>`).join('');

    const m = D.modelos[st.slots[st.active]];
    const mv = D.modelos[st.ver == null ? st.slots[st.active] : st.ver];
    const tEl = $('[data-md-elige-t]');
    if (tEl) tEl.textContent = n === 1 ? tEl.dataset.uno : tEl.dataset.pack.replace('[n]', n);
    $('[data-md-actual]').innerHTML = n === 1
      ? `Modelo elegido: <strong>n.º ${m.n} ${m.name}</strong>`
      : `Toca una plaza y luego el modelo que quieras`;

    $$('[data-md-modelo]').forEach((b) => {
      const i = +b.dataset.mdModelo;
      const usado = st.slots.slice(0, n).map((x, k) => (x === i ? k + 1 : 0)).filter(Boolean);
      b.classList.toggle('is-on', i === st.slots[st.active]);
      b.classList.toggle('is-used', usado.length > 0);
      b.setAttribute('aria-pressed', i === st.slots[st.active]);
      const ok = $('[data-md-ok]', b);
      if (ok) ok.textContent = !usado.length ? '' : n === 1 ? '✓' : usado.join('·');
    });

    const main = $('[data-md-main]');
    if (main && main.getAttribute('src') !== mv.img) {
      main.src = mv.img;
      const th = $('[data-md-main-thumb]');
      if (th) th.src = mv.thumb;
    }

    $('[data-md-sticky-pack]').textContent = n === 1 ? m.name : n + ' coches';
    $('[data-md-sticky-total]').textContent = fmt(t.total);
    const si = $('[data-md-sticky-img]');
    if (si) si.src = m.coche || m.thumb;
    $('[data-md-add-txt]').textContent = $('[data-md-add-txt]').dataset.base + ' · ' + fmt(t.total);
  }

  function initProducto() {
    if (!D) return;
    const addTxt = $('[data-md-add-txt]');
    addTxt.dataset.base = addTxt.textContent.trim();
    st.pack = Math.min(3, Math.max(1, D.pack || 2));
    const base = (D.inicial || 1) - 1;
    const ini = [base, ...[16, 8, 3, 0].filter((i) => i !== base).slice(0, 2)]
      .map((i) => (D.modelos[i] && D.modelos[i].ok ? i : firstOk()));
    st.slots = ini;
    st.active = 0;

    $$('[data-md-pack] input').forEach((r) => r.addEventListener('change', () => setPack(+r.value)));    $('[data-md-slots]').addEventListener('click', (e) => {
      const b = e.target.closest('[data-md-slot]');
      if (!b) return;
      st.active = +b.dataset.mdSlot;
      st.ver = null;
      render();
    });

    const mas = $('[data-md-mas]');
    if (mas) mas.addEventListener('click', () => {
      const lista = $('[data-md-modelos]');
      const abierta = lista.classList.toggle('is-todos');
      mas.textContent = abierta ? mas.dataset.txtMenos : mas.dataset.txtMas;
      if (!abierta) lista.closest('.md-elige').scrollIntoView({ block: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
    });

    $('[data-md-modelos]').addEventListener('click', (e) => {
      const b = e.target.closest('[data-md-modelo]');
      if (!b || b.disabled) return;
      st.slots[st.active] = +b.dataset.mdModelo;
      st.ver = st.slots[st.active];
      if (st.active < st.pack - 1) st.active += 1;
      render();
      const tr = $('[data-md-track]');
      if (tr) tr.scrollTo({ left: 0, behavior: reduce ? 'auto' : 'smooth' });
      setThumb(0);
    });

    $$('[data-md-add]').forEach((b) => b.addEventListener('click', () => add(false, b)));
    $$('[data-md-now]').forEach((b) => b.addEventListener('click', (e) => add(true, e.currentTarget)));

    render();
  }

  async function add(now, btn) {
    const err = $('[data-md-error]');
    err.hidden = true;
    const map = new Map();
    st.slots.slice(0, st.pack).forEach((i) => {
      const m = D.modelos[i];
      map.set(m.id, { id: m.id, quantity: (map.get(m.id)?.quantity || 0) + 1, properties: { Modelo: 'n.º ' + m.n + ' ' + m.name } });
    });
    btn.classList.add('is-busy');
    btn.disabled = true;
    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: Array.from(map.values()) }),
      });
      if (!r.ok) throw new Error((await r.json()).description || 'No se pudo añadir');
      if (now) { window.location.href = '/checkout'; return; }
      await openCart();
    } catch (e) {
      err.textContent = e.message || 'No se pudo añadir. Inténtalo de nuevo.';
      err.hidden = false;
    } finally {
      btn.classList.remove('is-busy');
      btn.disabled = false;
    }
  }

  /* ---------- Galería ---------- */
  function setThumb(i) {
    $$('[data-md-thumbs] button').forEach((b, k) => b.classList.toggle('is-on', k === i));
  }
  function initGaleria() {
    const tr = $('[data-md-track]');
    const th = $('[data-md-thumbs]');
    if (!tr || !th) return;
    tr.scrollLeft = 0;
    window.addEventListener('pageshow', () => { tr.scrollLeft = 0; setThumb(0); });
    th.addEventListener('click', (e) => {
      const b = e.target.closest('button');
      if (!b) return;
      const i = $$('button', th).indexOf(b);
      tr.scrollTo({ left: tr.clientWidth * i, behavior: reduce ? 'auto' : 'smooth' });
      setThumb(i);
    });
    let t;
    tr.addEventListener('scroll', () => {
      clearTimeout(t);
      t = setTimeout(() => setThumb(Math.round(tr.scrollLeft / tr.clientWidth)), 80);
    }, { passive: true });
  }

  /* ---------- Tramitación y entrega ---------- */
  const esLab = (d) => d.getDay() !== 0 && d.getDay() !== 6;
  function sumaLab(d, n) {
    const r = new Date(d);
    let k = 0;
    while (k < n) { r.setDate(r.getDate() + 1); if (esLab(r)) k++; }
    return r;
  }
  const may = (t) => t.charAt(0).toUpperCase() + t.slice(1);
  const dia = (d) => may(d.toLocaleDateString('es-ES', { weekday: 'short', day: 'numeric', month: 'short' }).replace(/\./g, '').replace(',', ''));
  const corto = (d) => d.toLocaleDateString('es-ES', { day: 'numeric', month: 'short' }).replace(/\./g, '');

  function initTramite() {
    if (!D || !$('[data-md-tramite]')) return;
    const txt = $('[data-md-corte-txt] span');
    function tick() {
      const now = new Date();
      const corte = new Date(now);
      corte.setHours(D.corte, 0, 0, 0);
      let base = new Date(now);
      if (esLab(now) && now < corte) {
        const s = Math.floor((corte - now) / 1000);
        const hms = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
        txt.innerHTML = 'Pide en las próximas <strong>' + hms + '</strong> y tramitamos tu pedido hoy';
        const cd = txt.querySelector('strong');
        if (!reduce && cd.animate) cd.animate([{ transform: 'translateY(-3px)', opacity: 0.55 }, { transform: 'none', opacity: 1 }], { duration: 320, easing: 'cubic-bezier(.23,1,.32,1)' });
      } else {
        base = sumaLab(now, 1);
        const manana = new Date(now); manana.setDate(now.getDate() + 1);
        const cuando = base.toDateString() === manana.toDateString() ? 'mañana' : 'el ' + base.toLocaleDateString('es-ES', { weekday: 'long' });
        txt.innerHTML = 'Pide ahora y tramitamos tu pedido <strong>' + cuando + '</strong>';
      }
      $('[data-md-f-hoy]').textContent = 'Hoy';
      $('[data-md-f-envio]').textContent = dia(sumaLab(base, D.tramite));
      $('[data-md-f-casa]').textContent = corto(sumaLab(now, D.entregaMin)) + ' - ' + corto(sumaLab(now, D.entregaMax));
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Oferta con fecha ---------- */
  function initOferta() {
    const bar = $('[data-md-oferta]');
    if (!bar) return;
    const fin = new Date(bar.dataset.mdOferta);
    const el = $('[data-md-oferta-cd]', bar);
    function tick() {
      const s = Math.floor((fin - new Date()) / 1000);
      if (isNaN(s) || s <= 0) {
        bar.hidden = true;
        const alt = $('[data-md-oferta-alt]');
        if (alt) alt.hidden = false;
        return false;
      }
      const d = Math.floor(s / 86400);
      el.textContent = (d ? d + 'd ' : '') + pad(Math.floor((s % 86400) / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
      return true;
    }
    if (tick()) { const t = setInterval(() => { if (!tick()) clearInterval(t); }, 1000); }
  }

  // Calendario de campañas de la barra de arriba: muestra la que toca por fecha y cambia sola
  function initCampanas() {
    const dataEl = $('[data-md-camp-data]');
    const bar = $('[data-md-camp]');
    if (!dataEl || !bar) return;
    let lista;
    try { lista = JSON.parse(dataEl.textContent); } catch (e) { return; }
    const fecha = (s) => (s ? new Date(s.trim().replace(' ', 'T')) : null);
    lista = lista.map((c) => ({ ...c, ini: fecha(c.ini), fin: fecha(c.fin), hasta: fecha(c.hasta) }));
    const alt = $('[data-md-camp-alt]');
    const tEl = $('[data-md-camp-t]', bar);
    const cdw = $('[data-md-camp-cdw]', bar);
    const cdt = $('[data-md-camp-cdt]', bar);
    const cd = $('[data-md-camp-cd]', bar);
    let actual = null;
    function tick() {
      const now = new Date();
      const c = lista.find((x) => x.t && (!x.ini || x.ini <= now) && (!x.fin || now < x.fin)) || null;
      if (c !== actual) {
        actual = c;
        bar.hidden = !c;
        if (alt) alt.hidden = !!c;
        if (c) { tEl.textContent = c.t; cdt.textContent = c.cdt || ''; }
      }
      if (!c) return;
      const meta = c.hasta || c.fin;
      const s = c.cd && meta ? Math.floor((meta - now) / 1000) : 0;
      cdw.hidden = !(s > 0);
      if (s > 0) {
        const d = Math.floor(s / 86400);
        cd.textContent = (d ? d + 'd ' : '') + pad(Math.floor((s % 86400) / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
      }
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Barra fija y apariciones ---------- */
  function initSticky() {
    const bar = $('[data-md-sticky]');
    const ctas = $('[data-md-ctas]');
    if (!bar || !ctas) return;
    // Barra flotante de compra visible desde que entras; solo se oculta mientras se ven los botones principales
    const io = new IntersectionObserver(([e]) => {
      const show = !e.isIntersecting;
      bar.classList.toggle('is-on', show);
      bar.setAttribute('aria-hidden', !show);
      $$('button', bar).forEach((b) => (b.tabIndex = show ? 0 : -1));
    });
    io.observe(ctas);
  }

  function initReveal() {
    const els = $$('[data-md-reveal]');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach((e) => e.classList.add('is-in')); return; }
    const io = new IntersectionObserver((es) => es.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    }), { rootMargin: '0px 0px -80px 0px' });
    els.forEach((e) => io.observe(e));
  }

  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-md-scroll]');
    if (!a) return;
    const t = $(a.getAttribute('href'));
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });

  /* ---------- Carrito lateral ---------- */
  const cartEl = $('[data-md-cart]');
  let lastFocus = null;

  function setCount(n) {
    $$('[data-md-cart-count]').forEach((c) => { c.textContent = n; c.hidden = !n; });
  }

  async function getCart() {
    const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return r.json();
  }

  // Ahorro real de cada pack (los mismos descuentos automáticos de Shopify)
  function ahorroPack(n) {
    if (!D) return 0;
    if (D.fijo && D.fijo[n - 1]) return D.fijo[n - 1];
    return 0;
  }

  function renderMeter(coches) {
    const el = $('[data-md-meter]');
    if (!el) return;
    if (!D || !coches) { el.hidden = true; return; }
    const a2 = ahorroPack(2), a3 = ahorroPack(3);
    let msg;
    if (coches >= 3) msg = a3 ? `<i class="ph-fill ph-flag-checkered" aria-hidden="true"></i><span><b>Pack Garaje desbloqueado:</b> ahorras ${fmt(a3)}</span>` : '<i class="ph-fill ph-flag-checkered" aria-hidden="true"></i><span><b>Pack Garaje desbloqueado</b></span>';
    else if (coches === 2) msg = `<i class="ph-fill ph-lightning" aria-hidden="true"></i><span><b>Pack Duelo activado${a2 ? ': ahorras ' + fmt(a2) : ''}.</b> Con 1 coche más${a3 ? ' ahorras ' + fmt(a3) : ''}</span>`;
    else msg = `<i class="ph-fill ph-lightning" aria-hidden="true"></i><span>Añade otro coche y ${a2 ? 'ahorras <b>' + fmt(a2) + '</b>' : 'activa el Pack Duelo'}</span>`;
    const pct = Math.min(coches, 3) === 1 ? 6 : Math.min(coches, 3) === 2 ? 50 : 100;
    const conos = D.conos ? coches * D.conos : 0;
    el.innerHTML = `
      <p class="md-meter__msg">${msg}</p>
      <div class="md-meter__track" aria-hidden="true">
        <span class="md-meter__fill" style="--p:${pct}%"></span>
        ${[1, 2, 3].map((k) => `<span class="md-meter__pt${coches >= k ? ' is-on' : ''}" style="--x:${k === 1 ? 6 : k === 2 ? 50 : 100}%"><i class="ph-fill ph-car-profile"></i></span>`).join('')}
      </div>
      <div class="md-meter__lbl" aria-hidden="true"><span>1 coche</span><span>Pack Duelo</span><span>Pack Garaje</span></div>
      ${conos ? `<p class="md-meter__regalo"><i class="ph-fill ph-traffic-cone" aria-hidden="true"></i>Incluye ${conos} conos de slalom de regalo</p>` : ''}`;
    el.hidden = false;
  }

  function renderCart(c) {
    setCount(c.item_count);
    const body = $('[data-md-cart-body]');
    const foot = $('[data-md-cart-foot]');
    const nEl = $('[data-md-cart-n]');
    const porId = D ? new Map(D.modelos.map((m) => [m.id, m])) : new Map();
    const coches = c.items.filter((i) => porId.has(i.variant_id)).reduce((a, i) => a + i.quantity, 0);
    if (nEl) nEl.textContent = c.item_count ? (coches ? `${coches} ${coches === 1 ? 'coche' : 'coches'}` : `${c.item_count}`) : '';
    renderMeter(coches);
    if (!c.item_count) {
      const portada = D && D.modelos[(D.inicial || 1) - 1];
      body.innerHTML = `<div class="md-cart__empty">
        ${portada && portada.coche ? `<img src="${portada.coche}" alt="" width="210" height="126">` : '<i class="ph ph-garage" aria-hidden="true"></i>'}
        <p><strong>Tu garaje está vacío</strong>Elige tu coche y empieza a derrapar.</p>
        <button type="button" class="md-btn md-btn--accent" data-md-close-cart>Elegir mi coche</button></div>`;
      foot.hidden = true;
      return;
    }
    body.innerHTML = c.items.map((it, k) => {
      const m = porId.get(it.variant_id);
      const props = it.properties && it.properties.Modelo ? it.properties.Modelo : (m ? 'n.º ' + m.n + ' ' + m.name : it.variant_title || '');
      const titulo = m ? m.name : it.product_title.split(' – ')[0];
      const img = (m && (m.coche || m.thumb)) || it.image || '';
      return `
      <div class="md-line" style="--i:${k}">
        <span class="md-line__img"><img src="${img}" alt="" width="120" height="72"></span>
        <div class="md-line__info">
          <strong>${titulo}</strong>
          <span>${m ? 'n.º ' + m.n + ' · Mini coche drift RC 1:64' : props}</span>
          <div class="md-line__row">
            <div class="md-qty">
              <button type="button" data-md-q="${k + 1}" data-v="${it.quantity - 1}" aria-label="Quitar uno"><i class="ph ph-minus"></i></button>
              <span>${it.quantity}</span>
              <button type="button" data-md-q="${k + 1}" data-v="${it.quantity + 1}" aria-label="Añadir uno"><i class="ph ph-plus"></i></button>
            </div>
            <button type="button" class="md-line__del" data-md-q="${k + 1}" data-v="0" aria-label="Quitar ${titulo}"><i class="ph ph-trash"></i></button>
          </div>
        </div>
        <div class="md-line__price">
          ${it.original_line_price !== it.final_line_price ? `<s>${fmt(it.original_line_price)}</s>` : ''}
          <strong>${fmt(it.final_line_price)}</strong>
        </div>
      </div>`;
    }).join('');

    const discs = (c.cart_level_discount_applications || []).map((d) => `<div class="md-sum__d"><dt><i class="ph-fill ph-tag" aria-hidden="true"></i>${d.title}</dt><dd>-${fmt(d.total_allocated_amount)}</dd></div>`).join('');
    const ahorro = c.original_total_price - c.total_price;
    $('[data-md-cart-sum]').innerHTML = `
      ${ahorro > 0 ? `<div><dt>Subtotal</dt><dd>${fmt(c.original_total_price)}</dd></div>${discs}` : ''}
      <div class="md-sum__t"><dt>Total</dt><dd>${ahorro > 0 ? `<em class="md-sum__ah">Ahorras ${fmt(ahorro)}</em>` : ''}${fmt(c.total_price)}</dd></div>
      <p class="md-sum__n">Gastos de envío calculados al pagar.</p>`;
    const pt = $('[data-md-pay-txt]');
    if (pt) pt.textContent = 'Finalizar compra · ' + fmt(c.total_price);
    foot.hidden = false;

    const up = $('[data-md-upsell]');
    if (D && (coches === 1 || coches === 2)) {
      const enCarrito = new Set(c.items.map((i) => i.variant_id));
      const sig = ahorroPack(coches + 1);
      const lista = D.modelos.filter((m) => m.ok && !enCarrito.has(m.id));
      up.innerHTML = `<p class="md-upsell__t">${coches === 1 ? 'Completa el duelo' : 'Completa tu garaje'}${sig ? ` <span>y ahorra ${fmt(sig)}</span>` : ''}</p>
        <div class="md-upsell__row">${lista.map((m) => `
          <button type="button" class="md-upsell__car" data-md-up="${m.id}" aria-label="Añadir ${m.name}">
            <span class="md-upsell__img"><img src="${m.coche || m.thumb}" alt="" width="120" height="72" loading="lazy"></span>
            <b>${m.name}</b>
            <span class="md-upsell__add"><i class="ph ph-plus" aria-hidden="true"></i>Añadir</span>
          </button>`).join('')}</div>`;
      up.hidden = false;
    } else up.hidden = true;
  }

  async function openCart() {
    if (!cartEl) { window.location.href = '/cart'; return; }
    renderCart(await getCart());
    lastFocus = document.activeElement;
    cartEl.hidden = false;
    requestAnimationFrame(() => cartEl.classList.add('is-open', 'is-entrando'));
    // Las líneas entran escalonadas solo al abrir, no en cada cambio de cantidad
    setTimeout(() => cartEl.classList.remove('is-entrando'), 900);
    document.documentElement.classList.add('md-lock');
    $('.md-cart__x', cartEl).focus();
  }

  function closeCart() {
    if (!cartEl || cartEl.hidden) return;
    cartEl.classList.remove('is-open');
    document.documentElement.classList.remove('md-lock');
    setTimeout(() => { cartEl.hidden = true; }, reduce ? 0 : 260);
    if (lastFocus) lastFocus.focus();
  }

  if (cartEl) {
    document.addEventListener('click', async (e) => {
      if (e.target.closest('[data-md-open-cart]')) { e.preventDefault(); openCart(); return; }
      if (e.target.closest('[data-md-close-cart]')) { closeCart(); if (e.target.closest('.md-cart__empty') && $('#md-packs')) $('#md-packs').scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' }); return; }
      const q = e.target.closest('[data-md-q]');
      if (q) {
        q.disabled = true;
        const r = await fetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: +q.dataset.mdQ, quantity: Math.max(0, +q.dataset.v) }),
        });
        renderCart(await r.json());
        return;
      }
      const u = e.target.closest('[data-md-up]');
      if (u) {
        u.disabled = true;
        const m = D.modelos.find((x) => x.id === +u.dataset.mdUp);
        await fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: m.id, quantity: 1, properties: { Modelo: 'n.º ' + m.n + ' ' + m.name } }] }),
        });
        renderCart(await getCart());
      }
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeCart(); });
  }

  // Valoración bajo el título: sale solo de las opiniones reales de la sección de opiniones
  function initRating() {
    const el = $('[data-md-rating]');
    const src = $('[data-md-resumen]');
    if (!el || !src) return;
    let r;
    try { r = JSON.parse(src.textContent); } catch (e) { return; }
    if (!r || !r.v || !r.v.length) return;
    const n = r.v.length;
    const min = +el.dataset.min || 4;
    const ok = r.v.filter((x) => x >= min).length;
    const media = Math.round((r.v.reduce((a, b) => a + b, 0) / n) * 10) / 10;
    let stars = '';
    for (let i = 1; i <= 5; i++) {
      const cls = media >= i - 0.25 ? 'ph-fill ph-star' : media >= i - 0.75 ? 'ph-fill ph-star-half' : 'ph ph-star';
      stars += '<i class="' + cls + '" aria-hidden="true"></i>';
    }
    $('[data-md-rating-stars]', el).innerHTML = stars;
    $('[data-md-rating-media]', el).textContent = media.toFixed(1).replace('.', ',');
    const plantilla = (ok === 1 ? el.dataset.txt1 : el.dataset.txt) || '[n]';
    $('[data-md-rating-txt]', el).textContent = (ok ? plantilla.replace('[n]', ok) : '') + (r.ejemplo ? ' (ejemplo, solo en el editor)' : '');
    el.setAttribute('aria-label', media.toFixed(1).replace('.', ',') + ' de 5 estrellas, ' + n + (n === 1 ? ' opinión' : ' opiniones'));
    el.hidden = false;
  }

  initRating();
  initProducto();
  initGaleria();
  initTramite();
  initOferta();
  initCampanas();
  initSticky();
  initReveal();
})();
